<i18n>
{
  "en":{
    "title": "CANDELA",
    "routes": {
      "systems": "Systems",
      "users": "Users",
      "pricelist": "Upload price list",
      "transactionreports": "Transaction Reports",
      "templatedefinitions": "Template Definitions"
    },
    "language": "Language",
    "about": "About",
    "user": {
      "user": "Profile",
      "settings": "Settings",
      "signout": "Sign out"
    }
  },
  "da":{
    "title": "CANDELA",
    "routes": {
      "systems": "Systemer",
      "users": "Brugere",
      "pricelist": "Upload prisliste",
      "transactionreports": "Transaktionsrapporter",
      "templatedefinitions": "Skabelondefinitioner"
    },
    "language": "Sprog",
    "about": "Om",
    "user": {
      "user": "Profil",
      "settings": "Indstillinger",
      "signout": "Log ud"
    }
  }
}
</i18n>

<template>
  <div class="wrapper">
    <b-navbar id="site-navbar" sticky class="header" toggleable="md" type="dark" variant="primary">

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand href="#">
        <img src="/logo_white.svg" class="logo">
        </img>
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav>
          <b-nav-item href="#" :to="{ name: 'systems' }" >{{$t('routes.systems')}} </b-nav-item>
          <b-nav-item href="#" :to="{ name: 'users' }" v-if="role === 'EllipseAdmin'">{{$t('routes.users')}}</b-nav-item>
          <b-nav-item href="#" :to="{ name: 'transactionreports' }" v-if="role === 'EllipseAdmin'">{{$t('routes.transactionreports')}}</b-nav-item>
          <b-nav-item href="#" :to="{ name: 'templatedefinitions' }" v-if="role === 'EllipseAdmin'">{{$t('routes.templatedefinitions')}}</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">

          <b-nav-item href="#" @click="showAbout = true">{{$t('about')}}</b-nav-item>

          <b-nav-item-dropdown :text="$t('language')" right class="test">
            <b-dropdown-item href="#" v-for="(lang, index) in languages" :key="index" @click="setLang(lang.value)" 
                    :active="language === lang.value" active-class="language-active" >
                {{lang.title}}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right>
            <!-- Using button-content slot -->
            <template slot="button-content">
              {{$t('user.user')}}
            </template>
            <b-dropdown-item disabled>{{name}}</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="test()">{{$t('user.settings')}}</b-dropdown-item>
            <b-dropdown-item href="#" v-on:click="logoutUser" >{{$t('user.signout')}}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <div class="content">
      <slot></slot>
    </div>

    <div class="footer">
      <!-- <svg version="1.1" id="Layer_1" xmlns="&ns_svg;" xmlns:xlink="&ns_xlink;" width="64.705" height="42.064" viewBox="0 0 64.705 42.064" overflow="visible" enable-background="new 0 0 64.705 42.064" xml:space="preserve">-->
      <svg version="1.1" id="Layer_1" xmlns="&ns_svg;" xmlns:xlink="&ns_xlink;" width="21.56" height="14.02" viewBox="0 0 64.705 42.064" overflow="visible" enable-background="new 0 0 64.705 42.064" xml:space="preserve">
        <g>
          <path d="M0,42.064L24.258,0l24.258,42.064H40.43L24.24,14.08L8.086,42.064H0z M16.172,42.064l10.793-18.686l4.043,7.014l-2.707,4.658h5.396l4.043,7.014H16.172z M33.68,11.707l6.75-11.672l24.275,42.029H51.223l-4.061-7.014h5.414L40.412,14.063l-2.672,4.658L33.68,11.707z"/>
        </g>
      </svg>

       Logos Design A/S | Nærum Hovedgade 6 | DK-2850 Nærum, Danmark | Tel +45 45 87 78 99
    </div>
  
    <!-- <user-modal v-model="showUserDialog" />-->
    <user-modal modal-action="edit" :visible.sync="showUserDialog" :user.sync="user" v-on:success="pling"></user-modal>
    <about v-model="showAbout"></about>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import roles from '../utils/roles.js'
import errorParser from '../utils/errorParser.js'
import elg from '../api/elg.gateway.js'
import jwt from '../utils/jwt.js'

import UserModal from './UserModal'
import About from './About'

export default {
  components: {
    UserModal,
    About
  },
  data() {
    return {
      language: 'en',
      languages: [
        { title: 'English', value: 'en' },
        { title: 'Dansk', value: 'da' }
      ],
      user: {
        Role: undefined,
        ReferenceUser: {
          ReferenceUsername: ''
        },
        Limits: { }
      },
      showUserDialog: false,
      showAbout: false,
    }
  },
  methods: {
    ...mapActions(['logout']), 
    logoutUser() {
      this.logout();
      window.location.href = '/'; // Hard-reset of page
    },
    setLang (language) {
      localStorage.setItem('language', language);
      this.language = language;
      this.$root.$i18n.locale = language;
      this.$set(this.$root.$i18n, 'locale', language);
      this.$validator.localize(language);
      /*var flatpickrLanguage = {
        "da": FlatpickrDanish,
        "en": FlatpickrEnglish
      }
      flatPickr.localize(flatpickrLanguage[language]); */

    },
    test() {
      elg()
      .get(`/api/v1/users/me`)
      .then( res => {
        this.user = res.data;
        this.user.Role = roles(this.user.RoleID);
        this.showUserDialog = true;
      })
    },
    pling(res){
      this.$emit('onUserUpdate', res);
    },
    editUser(){
      // Actual code
      this.user.RoleID = roles(this.user.Role);
      elg()
      .put(`/api/v1/users/${this.user.UserID}`, this.user)
      .then( res => {
        this.$set(this.users, this.user.index, this.user);
        this.$refs.userForm.hide();
        this.reset();
      })
      .catch( err => {
        errorParser.parseErrors(this.$validator, this.$options, err);
      })
    },
    showEditUser(data){
      this.modalAction = 'edit';
      this.user.Role = roles(this.user.RoleID);
      this.$refs.userForm.show();
    },

  },
  mounted(){
    var lang =  localStorage.getItem('language');
    if( lang !== undefined && lang !== null ){
      this.setLang(lang);
    }else{
      this.setLang('en');
    }
  },
  computed: {
    role() {
      return jwt.getRole()
    },
    name(){
      return jwt.getName()
    }
  }
};
</script>

<style scoped>
  
  .language-active {
    font-weight: bold !important;
  }

  .logo {
    max-height: 60px;
    margin-bottom: -20px;
    margin-top: -20px;
    margin-left: -25px;
  }

  .header {
    background-color: #000000 !important;
  }

  .candela_text{
    color:#A6228C!important
  }

  .router-link-exact-active{
    font-weight: bold
  }

  .content {
    padding-bottom: 35px;
  }

  .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      min-height: 35px;
      background-color: #ececec;
      color: black;
      text-align: center;
      padding-top:5px;
  }
</style>


// WEBPACK FOOTER //
// WebApp/components/Layout.vue